import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Splash from "../../../splash/Splash";
import NoData from "../../common/mobile/NoData";
import Footer from "../../layout/mobile/Footer";
import GuestToolbar from "../../layout/mobile/GuestToolbar";
import MobileHeader from "../../layout/mobile/MobileHeader";
import Toolbar from "../../navigation/mobile/Toolbar";

function Games() {
    const [games, setGames] = useState([]);
    const [filteredGames, setFilteredGames] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [providers, setProviders] = useState([]);
    const [setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoggedIn] = useState(!!localStorage.getItem('token')); 
     const [hide, setHide] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const origin = window.location.origin;

    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');
    const system = searchParams.get('system');
    const title = searchParams.get('title');
    console.log(type, system, title);
    const [activeProvider, setActiveProvider] = useState(system ? system.split(',') : []);


	const imgUrl = (game) => {
		let slug = game?.slug || false;
		if (!slug) {
			let code = game.code.replace(/\s\s/g, ' ').replace(/\s/g, '_').toLowerCase();
			let name = game.name.replace(/\s\s/g, ' ')
				.replace(/!/g, '')
				.replace(/\?/g, '')
				.replace(/\//g, '')
				.replace(/\s/g, '_')
				.replace(/'/g, '_')
				.toLowerCase();
			slug = `${code}_${name}.png`.replace(/\s\s/g, ' ').replace(/\s/g, '_');
		}
		return `https://api2b.pro/poster/${slug}`;
	}
  


    const filtterOpen = () => {
        const chatElement = document.querySelector('.searchpage');
        chatElement.classList.add('active');
        const subEmlemt = document.querySelector('.searchpage-bar');
        subEmlemt.classList.add('active');
    };

    const filtterClose = () => {
        const chatElement = document.querySelector('.searchpage');
        chatElement.classList.remove('active');
        const subEmlemt = document.querySelector('.searchpage-bar');
        subEmlemt.classList.remove('active');
    };

    // Memoize fetchGames and fetchSystems
    const fetchGames = useCallback((currentSystem) => {
        const url = `${process.env.REACT_APP_API_URL}/api/get-games?type=${type}&system=${currentSystem}`;
        console.log('Fetching data from:', url);
        fetch(url)
          .then(response => response.json())
          .then(data => {
            setGames(data.games);
            setFilteredGames(data.games);
            console.log(data);
          })
          .catch(error => {
            console.error('Error fetching games:', error);
            setError('Failed to fetch games');
          });
    }, [type, setError]);

    // Store systems order for sorting providers
    const [systemsOrder, setSystemsOrder] = useState([]);

    // Move fetchProviders function above useCallback
    const fetchProviders = useCallback(async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                // Sort providers by the order they appear in systems array
                const providerData = data.data || [];
                const sorted = providerData.sort((a, b) => {
                    const indexA = systems.indexOf(a.platform);
                    const indexB = systems.indexOf(b.platform);
                    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
                });
                setProviders(sorted);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    }, [setError]);

    const fetchSystems = useCallback(async (type) => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystemsOrder(data.systems || []); // Store systems order
                fetchProviders(data.systems); // Fetch providers once systems are fetched
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        } finally {
            setIsLoading(false);
        }
    }, [fetchProviders, setError]);

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);
        const filtered = games.filter(game => game.name.toLowerCase().includes(query));
        setFilteredGames(filtered);
    };

    const handleGameClick = async (gameCode, gamePlatform, gameType) => {
      if (!isLoggedIn) {
        navigate('/login');
        return;
      }
      setIsLoading(true);

      try {
        const token = localStorage.getItem('token');
        const remote_id = localStorage.getItem('remote_id');
        if (!token || !remote_id) {
          setError('User not logged in');
          return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            userId: remote_id,
            externalURL: origin,
            gameCode,
            gameType,
            platform: gamePlatform,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
          if (iframeUrl) {
            navigate('/gamerun', {
              state: {
                iframeUrl,
                fromParams: { type, system, title },
              },
            });
          } else {
            setError(data.message || 'Missing game URL in response');
          }
        } else {
          setError(data.message || 'An unexpected error occurred');
        }
      } catch (error) {
        setError('An unexpected error occurred');
      } finally {
        setIsLoading(false);
      }
    };

    const handleProviderClick = (providerSystem) => {
      let updatedProviders = [];
    
      if (providerSystem === "ALL") {
        const shouldSelectAll = activeProvider.length !== providers.length;
        updatedProviders = shouldSelectAll ? providers.map(provider => provider.platform) : [];
      } else {
        updatedProviders = activeProvider.includes(providerSystem)
          ? activeProvider.filter(provider => provider !== providerSystem)
          : [...activeProvider, providerSystem];
      }
    
      setActiveProvider(updatedProviders);
      fetchGames(updatedProviders);
    };

   


    useEffect(() => {
      if (type && system) {
          fetchGames(system);
          fetchSystems(type);
      } else {
          console.error("Type or system is missing", { type, system });
      }
    }, [type, system, fetchGames, fetchSystems]);
    
    if(isLoading) {
      return(
     <Splash/>
      );
    }
  return (
    <div className="main-router-wrapper">
      <MobileHeader />
      <div className="wrap">
        <div className="content">
          <div className="content-main">
            <div className="content-box">
              <div className="games">
                <div className="tab search-tab brand-tab">
                  <ul className="item-ani">
                  <li
                            onClick={() => handleProviderClick("ALL")}
                            className={`condition-groups ${activeProvider.length === providers.length ? 'active' : ''}`}
                          >
                            <div
                              className="icon-all"
                              style={{
                                backgroundImage: 'url("./icons/icon-all-provider.svg")',
                              }}
                            />
                            <p>ALL</p>
                          </li>

                    {providers.map((provider) => (
                        <li
                          onClick={() => handleProviderClick(provider.platform)}
                          className={`condition-groups ${activeProvider.includes(provider.platform) ? 'active' : ''}`}
                          key={provider.platform}
                        >
                          <div className="condition-groups__inner">
                            <img
                              src={`${process.env.REACT_APP_API_URL}/provider/${provider.platform}.png`} 
                              alt={provider.platform}
                              loading="lazy"
                            />
                            <p>{provider.platform}</p>
                          </div>
                        </li>
                      ))}

                  </ul>
                  <div onClick={filtterOpen} className="btn search-btn">
                    <span
                      className="item-icon"
                      style={{
                        maskImage:
                          'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-search-type02.svg?v=1730201806250")',
                      }}
                    />
                  </div>
                </div>
                <div className="sort-bar">
                  <div className="sort-bar__title">
                    <span>{title}</span>
                  </div>
                  <div className="sort-bar__box">
                    <div className="sort-bar__btn">
                      <span>Filter</span>
                      <span
                        className="arrow"
                        style={{
                          maskImage:
                            'url("https://www.jeetbuzz.com/assets/images/icon-set/icon-arrow-type06.svg")',
                        }}
                      />
                    </div>
                    <ul className="sort-bar__select">
                      <li className="sort-bar__select__item" id="sort_recommend">
                        <span id="sort_recommend">Recommend</span>
                      </li>
                      <li className="sort-bar__select__item" id="sort_latest">
                        <span id="sort_latest">Latest</span>
                      </li>
                      <li className="sort-bar__select__item" id="sort_favorite">
                        <span id="sort_favorite">Favorite</span>
                      </li>
                      <li className="sort-bar__select__item" id="sort_aZ">
                        <span id="sort_aZ">A-Z</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="searchpage">
                  <div className="search-top-info">
                    <div onClick={filtterClose} className="back">
                      <span
                        className="item-icon"
                        style={{
                          maskImage:
                            'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-arrow-type09.svg?v=1730201806250")',
                        }}
                      />
                      Back
                    </div>
                    <div
                      className="icon-search"
                      style={{
                        maskImage:
                          'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-search-type02.svg?v=1730201806250")',
                      }}
                    />
                    <input
                      type="text"
                      className="ng-untouched ng-pristine ng-valid"
                      placeholder="Search Games"
                      name="search"
                      value={searchQuery}
                      onChange={handleSearch}
                      autocomplete="off"
                  />

                  </div>
                  <div className="searchpage-main">
                    <div className="search-checkbox-group check-group">
                      <h2>Providers</h2>
                      <ul>
                  <li  onClick={() => handleProviderClick('ALL')}>
                    <input
                      type="checkbox"
                      checked={activeProvider.length === providers.length} // Check if all providers are selected
                      // Handle "ALL" toggle
                    />
                    <label>
                      <span>All</span>
                    </label>
                  </li>
                  
                  {providers.map((provider, index) => (
                    <li onClick={() => handleProviderClick(provider.platform)} key={index}>
                      <input
                        type="checkbox"
                        checked={activeProvider.includes(provider.platform)} // Check if this provider is in activeProvider
                         // Toggle individual provider
                      />
                      <label>{provider.platform}</label>
                    </li>
                  ))}
                </ul>

                    </div>
                    
                  </div>
                  <div onClick={filtterClose} className="searchpage-bar">
                    <button className="button">Confirm</button>
                  </div>
                </div>
                <div className="games-main">
                      {filteredGames.length > 0 ? (
                    
                          filteredGames.map(
                            
                            (game) =>
                                <div
                                  key={game.code}
                                  onClick={() => handleGameClick(game.uid, game.platform, game.type)}
                                  className="games-box ng-trigger ng-trigger-staggerFadeAnimation"
                                >
                                  <div className="pic item-ani">
                                    <Link>
                                    <img
										src={imgUrl(game)}
										alt={game.name}
										loading="lazy"
										onError={(e) => {
											const card = e.currentTarget.closest('.games-box');
											if (card) card.style.display = 'none';
										}}
									/>
                                    </Link>
                                  </div>
                                  <div className="text item-ani">
                                    <h3>{game.name}</h3>
                                    <div
                                      className="like"
                                      style={{
                                        backgroundImage:
                                          'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-heart-type02.svg?v=1730201806250")',
                                      }}
                                    />
                                  </div>
                                </div>
                              
                          )
                        
                      ) : (
                        <NoData/>
                      )}
                    </div>
                <div className="prompt">－end of page－</div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {isLoggedIn ? (
                  <Toolbar/>
              ) : (
                  <GuestToolbar/>
              )}
    </div>
  );
}

export default Games;
